import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { PatentLayoutRequestType, PatentLayoutResponseType } from '../patent-layout-api'
import type { IPatentLayoutV2Api } from '../patent-layout-v2-api'

@injectable()
export class PatentLayoutV2ApiImpl extends PsHttpService implements IPatentLayoutV2Api {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-lca-agent-api`,
        }
    }

    getLayoutByPatent(params: PatentLayoutRequestType) {
        return this.post<PatSnapCommonResponseData<PatentLayoutResponseType>>({
            url: '/patent/layout_ocsr_v2',
            data: params,
        }).then(res => {
            return (res || {}) as unknown as PatentLayoutResponseType
        })
    }
}
